// extracted by mini-css-extract-plugin
export default {"link":"AuthNav_link__1DYPd","active":"AuthNav_active__gfkpa"};